module.exports = __webpack_public_path__ + "static/superfreakonomics-4d28dd669d28c7e275093fff007a760b.jpg";